import React, { useRef, useState } from 'react';
import * as XLSX from 'xlsx';

const ExportToExcel = ({ data }) => {
  
    const tableRef = useRef();

    const handleExport = () => {
      if (data != null || data != "" || data != undefined) {
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.table_to_sheet(tableRef.current);
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        XLSX.writeFile(wb, 'table_data.xlsx');
      }  
    };

  const convertISTTime = (date) => {
    if (date != null || date != "" || date != undefined) {
        const [datePart, TimePart] = date.split("T");
        const [yyyy, mm, dd] = datePart.split("-");
        // const [hh, mn, ss] = TimePart.split(':')
        const formatedTime = `${dd}-${mm}-${yyyy}`;
        return formatedTime;
    } else {
        console.warn("input date string may be null, empty string or undefined");
    }
};

  return (
    <div>
      <table ref={tableRef}>
        <thead>
          <tr>
            <th>Person Name</th>
            <th>Flat Number</th>
            <th>Vehicle Number</th>
            <th>Vehicle Type</th>
            <th>Vehicle Category</th>
            <th>Entry Date</th>
            <th>Entry Gate</th>
            <th>Transit Remark</th>
          </tr>
        </thead>
        <tbody>
          {data ?  data?.map((item, index) => (
            <tr key={index}>
              <td>{item?.personName}</td>
              <td>{item?.towerName} - {item?.flatName}</td>
              <td>{item?.lpNumber}</td>
              <td>{item?.vehicleType}</td>
              <td>{item?.vehicleCategory}</td>
              <td>{convertISTTime(item?.entryDt)}</td>
              <td>{item?.entryGateName}</td>
              <td>{item?.transitRemark}</td>
            </tr>
          )) : null}
        </tbody>
      </table>
      <button onClick={handleExport}>Export Selected to Excel</button>
    </div>
  );
};

export default ExportToExcel;
